// 1. External Libraries
import React from 'react';

// 2. Components
import Text from './Text';
import Button from './Button';
import Loading from './Loading';

interface ActionConfirmationModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  onFirstButtonAction?: () => void;
  onFirstButtonName?: string;
  isFirstButtonRequired?: boolean;
  isFirstButtonDisabled?: boolean;
  onSecondButtonAction?: () => void;
  onSecondButtonName?: string;
  isSecondButtonRequired?: boolean;
  error?: string | null;
}

const ActionConfirmationModal: React.FC<ActionConfirmationModalProps> = ({
  isOpen,
  title,
  message,
  onFirstButtonAction,
  onFirstButtonName,
  isFirstButtonRequired = false,
  isFirstButtonDisabled = false,
  onSecondButtonAction,
  onSecondButtonName,
  isSecondButtonRequired = false,
  error,
}) => {
  if (!isOpen) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-container grid gap-24">
        <div className="popup-content d-flex gap-8">
          <Text className="large-semibold">{title}</Text>
          <Text className="label-small">{message}</Text>
        </div>
        <div className="grid gap-12">
          {error && (
            <div className="error-message text-align-center">
              <Text>{error}</Text>
            </div>
          )}
          {isFirstButtonRequired && (
            <Button
              type="button"
              className="primary-button"
              onClick={onFirstButtonAction}
              disabled={isFirstButtonDisabled}
            >
              {isFirstButtonDisabled ? (
                <>
                  <Loading size={25} /> &nbsp;
                  {onFirstButtonName}
                </>
              ) : (
                onFirstButtonName
              )}
            </Button>
          )}
          {isSecondButtonRequired && (
            <Button
              type="button"
              className="secondary-button"
              onClick={onSecondButtonAction}
            >
              {onSecondButtonName}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ActionConfirmationModal;
